module.exports = __webpack_public_path__ + "img/method.c4f2dbc7.svg";